import React, { useEffect, useState } from "react";

import Chart from "react-apexcharts";
import ApexCharts from "apexcharts";
import styled from "@emotion/styled";

import { css } from "@emotion/react";
import { responsive } from "../../utils/style";

import { Dropdown, Button, Menu } from "antd";

import downloadIcon from "../../assets/icons/downloadBtnIcon.svg";

import { getHeightMeasureText, getWeightMeasureText } from "./constants";
import * as XLSX from "xlsx";

const downloadChartPNG = (chartId) => () => {
  const ac = ApexCharts.getChartByID(chartId);
  ac.exports.exportToPng();
};

const getTableData = (dataTable) => {
  const { dataSource, sd, mean, median } = dataTable;
  let isIndividual = true;
  let weeks = dataSource.map((d) => {
    if (d["User.nickname"]) isIndividual = false;
    return {
      ...(isIndividual ? { week: d.week } : { nickname: d["User.nickname"] }),
      ...d,
      heightForAge: getHeightMeasureText(d.heightForAge),
      weightForHeight: getWeightMeasureText(d.weightForHeight),
      days: d.days,
      rewards: d.rewards.join(", "),
      rank: d.rank,
    };
  });
  weeks.push({
    ...mean,
    totalCowMilkScore: mean.cowMilkScore,
    totalVegetableScore: mean.vegetableScore,
    totalExerciseScore: mean.exerciseScore,
    totalSweetDrinkScore: mean.sweetDrinkScore,
    totalVegetableQuantity: mean.vegetableQuantity,
    totalExerciseMinutes: mean.exerciseMinutes,
    ...(isIndividual ? { week: "ค่าเฉลี่ย" } : { nickname: "ค่าเฉลี่ย" }),
  });
  weeks.push({
    ...sd,
    totalCowMilkScore: sd.cowMilkScore,
    totalVegetableScore: sd.vegetableScore,
    totalExerciseScore: sd.exerciseScore,
    totalSweetDrinkScore: sd.sweetDrinkScore,
    totalVegetableQuantity: sd.vegetableQuantity,
    totalExerciseMinutes: sd.exerciseMinutes,
    ...(isIndividual
      ? { week: "ส่วนเบี่ยงเบน มาตรฐาน" }
      : { nickname: "ส่วนเบี่ยงเบน มาตรฐาน" }),
  });
  weeks.push({
    ...median,
    totalCowMilkScore: median.cowMilkScore,
    totalVegetableScore: median.vegetableScore,
    totalExerciseScore: median.exerciseScore,
    totalSweetDrinkScore: median.sweetDrinkScore,
    totalVegetableQuantity: median.vegetableQuantity,
    totalExerciseMinutes: median.exerciseMinutes,
    ...(isIndividual ? { week: "มัธยฐาน" } : { nickname: "มัธยฐาน" }),
  });
  console.log(weeks);
  return weeks;
};

export const DownloadButton = ({
  dataTable,
  chartId,
  style,
  csvHeaders,
  details,
}) => {
  const downloadExcel = (data) => {
    const worksheet = XLSX.utils.aoa_to_sheet(details);
    const haededData = data.map((d) => {
      const headed = csvHeaders.reduce((mem, cur) => {
        mem[cur.label] = d[cur.key];
        return mem;
      }, {});
      return headed;
    });
    XLSX.utils.sheet_add_json(worksheet, haededData, { origin: "A3" });
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    XLSX.writeFile(workbook, `report#${new Date().toDateString()}.xlsx`);
  };
  return (
    <Dropdown
      overlay={
        <Menu>
          <Menu.Item
            key={"menuDownloadCSV"}
            onClick={() => downloadExcel(getTableData(dataTable))}
          >
            ตาราง (XLSX)
          </Menu.Item>
          <Menu.Item
            key={"menuDownloadChart"}
            onClick={downloadChartPNG(chartId)}
          >
            แผนภูมิ (Chart)
          </Menu.Item>
        </Menu>
      }
      placement="topLeft"
      arrow
    >
      <DownloadBtn style={style}>
        {" "}
        <img src={downloadIcon} style={{ marginRight: "8px" }} />
        ดาวน์โหลด
      </DownloadBtn>
    </Dropdown>
  );
};

const ReportChart = ({
  chartData,
  dataTable,
  chartOption,
  csvHeaders,
  details,
}) => {
  return (
    <ChartContainer>
      <Chart
        options={chartOption}
        series={chartData}
        type="scatter"
        height={450}
        width={"100%"}
      />
      <DownloadButton
        dataTable={dataTable}
        chartId={chartOption.chart.id}
        style={{ marginRight: 10 }}
        csvHeaders={csvHeaders}
        details={details}
      />
    </ChartContainer>
  );
};

const ChartContainer = styled.div`
  margin-top: 16px;
  max-width: 770px;
  width: 100%;

  .apexcharts-title-text {
    white-space: pre-line;
  }

  ${responsive.mobile(css`
    width: calc(100% - 64px);
  `)}
`;

const DownloadBtn = styled(Button)`
  cursor: pointer;
  font-family: "Noto Sans Thai";
  font-style: normal;
  font-weight: 600;
  font-size: 19px;
  line-height: 23px;
  /* identical to box height, or 121% */

  letter-spacing: -0.02em;

  /* Primary/Green 400 */

  color: #16af7b;
  padding: 14px 31px 35px;

  /* Primary/Green 50 */

  background: #b5f6df;
  /* Primary/Green 400 */

  border: 1px solid #16af7b;
  border-radius: 100px;
  float: right;

  :hover,
  :focus,
  :active {
    border: 1px solid #16af7b;
    color: #16af7b;
    background: #b5f6df;
  }
`;

export default ReportChart;
